import axios from 'axios';
import React, { FC, ReactNode, useEffect } from 'react';
import { MfaChallenge } from '../../../../interfaces/MfaChallenge';
import transformFactorsRequest from './transformFactorsRequest';

export interface AsyncPostFactorsProps {
  children: ReactNode;
  url: string;
  emailChallenge: MfaChallenge;
  smsChallenge: MfaChallenge;
  onConfirmFactorCalled: () => void;
}

const AsyncPostFactors: FC<AsyncPostFactorsProps> = ({ children, url, emailChallenge, smsChallenge, onConfirmFactorCalled }) => {
  useEffect(() => {
    const axiosPost = () => {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      axios.post(url, transformFactorsRequest(emailChallenge, smsChallenge), {
        headers: { 'Content-Type': 'application/json' },
      });

      sessionStorage.setItem('mfaConfirmationTime', new Date().toISOString());
      onConfirmFactorCalled();
    };

    axiosPost();
  }, [url, emailChallenge, smsChallenge, onConfirmFactorCalled]);

  return <>{children}</>;
};

export default AsyncPostFactors;
